<template>
    <Notification/>
</template>
<script>
import Notification from 'place/evaluation/notification.vue'
export default {
    components:{
        Notification
    }
}
</script>
t